import { render, staticRenderFns } from "./BalanceChangeLog.vue?vue&type=template&id=723bb837&scoped=true"
import script from "./BalanceChangeLog.vue?vue&type=script&lang=js"
export * from "./BalanceChangeLog.vue?vue&type=script&lang=js"
import style0 from "./BalanceChangeLog.vue?vue&type=style&index=0&id=723bb837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723bb837",
  null
  
)

export default component.exports